import React from 'react'
import PropTypes from 'prop-types'
import './TextField.scss'

const TextField = ({
  id,
  label,
  subLabel,
  placeholder,
  disabled,
  errorMessage,
  type,
  isValid,
  name,
  autoCompleteName,
  value,
  onChange,
  maxLength,
}) => {
  return [
    <label className="Textfield__label" key="label">
      {label}
      {subLabel && <span className="Textfield__sublabel">{subLabel}</span>}
    </label>,
    <input
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      maxLength={maxLength}
      key={id}
      id={id}
      type={type}
      className={`Textfield ${isValid === false ? 'invalid' : ''}`}
      name={name}
      autoComplete={autoCompleteName}
      onChange={e => onChange(id, e.target.value)}
    />,
    isValid === false && (
      <span className="Textfield__error-message" key="errorMessage">
        {errorMessage}
      </span>
    ),
  ]
}

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['email', 'text', 'number']).isRequired,
  required: PropTypes.bool,
  validation: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  autoCompleteName: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  info: PropTypes.string,
  active: PropTypes.bool,
  autoComplete: PropTypes.bool,
  isValid: PropTypes.bool,
  maxLength: PropTypes.number,
}

export default TextField
